import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import AdminHeader from "../../../Component/AdminHeader/AdminHeader";
import "./ListStalls.css";

export default function ListStalls() {
  const location = useLocation();
  const navigate = useNavigate();

  const owner_id = location.state?.owner_id;

  const [owner, setOwner] = useState(null);
  const [stalls, setStalls] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);

  const API = "https://fliplyn-b-c.fly.dev";

  // 🟢 Log on page load
  useEffect(() => {
    console.log("========= LIST STALLS SCREEN LOADED =========");
    console.log("owner_id received from previous screen =>", owner_id);
    console.log(
      owner_id
        ? "🟢 owner_id exists — OK"
        : "❌ owner_id MISSING — previous navigate did not pass it"
    );
    console.log("============================================");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // run only once on mount

  // Fetch owner and stalls data
  useEffect(() => {
    if (!owner_id) return;

    const fetchData = async () => {
      try {
        const [ownerRes, stallsRes] = await Promise.all([
          axios.get(`${API}/owners/${owner_id}`),
          axios.get(`${API}/stalls/owner/${owner_id}`),
        ]);

        setOwner(ownerRes.data);
        setStalls(stallsRes.data);

        console.log("🟢 OWNER DETAILS LOADED:", ownerRes.data);
        console.log("🟢 STALLS LOADED:", stallsRes.data);
      } catch (error) {
        console.error("❌ Error loading data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [owner_id]);

  if (!owner_id) {
    return (
      <h2 style={{ textAlign: "center", marginTop: 50 }}>
        ❌ Owner ID Missing — cannot load stalls
      </h2>
    );
  }

  const filteredStalls = stalls.filter((s) =>
    s.name?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="stall-dashboard-container">
      <AdminHeader />

      {loading ? (
        <h2 style={{ textAlign: "center", marginTop: 40 }}>Loading...</h2>
      ) : (
        <>
          {/* Owner Card */}
          <div className="stall-owner-card">
            <div className="stall-owner-left">
              <div className="stall-owner-avatar">👤</div>
              <div>
                <h2 className="stall-owner-name">{owner?.owner_name}</h2>
                <p className="stall-company-name">{owner?.company_name}</p>

                <span
                  className={`stall-active-badge ${
                    owner?.is_active ? "active" : "inactive"
                  }`}
                >
                  {owner?.is_active ? "Active Owner" : "Inactive Owner"}
                </span>
              </div>
            </div>

            <div className="stall-owner-right">
              <div className="stall-info-row">
                <span className="stall-label">PHONE NUMBER</span>
                <span className="stall-value">{owner?.phone_number}</span>
              </div>

              <div className="stall-info-row">
                <span className="stall-label">LOCATION</span>
                <span className="stall-value">
                  {owner?.address?.city}, {owner?.address?.state},{" "}
                  {owner?.address?.country}
                </span>
              </div>

              <div className="stall-button-row">

                <button
                  className="stall-add-outlet-btn"
                  onClick={() =>
                    navigate("/add-outlet-form", { state: { owner_id } })
                  }
                >
                  + Add Outlet
                </button>
              </div>
            </div>
          </div>

          {/* Filters Section */}
          <div className="stall-filters-section">
            <input
              className="stall-search-box"
              placeholder="Search outlets..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />

            <select className="stall-filter-select">
              <option>Owner</option>
            </select>
            <select className="stall-filter-select">
              <option>Availability</option>
            </select>
            <select className="stall-filter-select">
              <option>Opening Time</option>
            </select>
            <select className="stall-filter-select">
              <option>Sort</option>
            </select>

            <button className="stall-reset-btn" onClick={() => setSearch("")}>
              Reset
            </button>

            <button
              className="stall-add-outlet-btn stall-right-add"
              onClick={() =>
                navigate("/add-outlet-form", { state: { owner_id } })
              }
            >
              + Add Outlet
            </button>
          </div>

          {/* Stalls Table */}
          <div className="stall-table-container">
            <table className="stall-table">
              <thead>
                <tr>
                  <th>Outlet</th>
                  <th>Owner</th>
                  <th>Opening Time</th>
                  <th>Closing Time</th>
                  <th>Availability</th>
                </tr>
              </thead>

              <tbody>
                {filteredStalls.length > 0 ? (
                  filteredStalls.map((out) => (
                    <tr
                      key={out.id}
                      className="stall-row"
                      onClick={() =>
                        navigate("/list-category", {
                          state: {
                            stall_id: out.id,
                            owner_id: owner_id,
                            stall: out,
                            owner: owner,
                          },
                        })
                      }
                    >
                      <td className="stall-outlet-info">
                        <img
                          src={out.image_url}
                          alt=""
                          className="stall-outlet-icon"
                        />
                        <div>
                          <div className="stall-outlet-name">{out.name}</div>
                          <div className="stall-description">{out.description}</div>
                        </div>
                      </td>

                      <td>{owner?.owner_name}</td>
                      <td>{out.opening_time}</td>
                      <td>{out.closing_time}</td>

                      <td>
                        <span
                          className={
                            out.is_available
                              ? "stall-status stall-status-available"
                              : "stall-status stall-status-paused"
                          }
                        >
                          {out.is_available ? "Available" : "Paused"}
                        </span>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" style={{ textAlign: "center", padding: 20 }}>
                      No stalls found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
}
